import { useMutation, useQueryClient } from '@tanstack/react-query'
import { httpsCallable } from 'firebase/functions'

import { functions } from '@/firebase'

/**
 * Purchase top-off credits for the current user
 */

interface PurchaseTopOffCreditsParams {
  priceId: string
  paymentMethodId: string
  saveCard?: boolean
}
interface PurchaseTopOffCreditsResult {
  data: {
    success: boolean
    paymentIntentId: string
    creditsAdded: number
    stripeCustomerId: string
    error?: string
    message?: string
  }
}

const purchaseTopOffCredits = async ({ priceId, paymentMethodId, saveCard = false }: PurchaseTopOffCreditsParams) => {
  try {
    const purchaseFunction = httpsCallable(functions, 'purchaseCreditTopoff')
    const result = await purchaseFunction({ priceId, paymentMethodId, saveCard }) as PurchaseTopOffCreditsResult

    if (result.data.error) {
      throw new Error(result.data.message || 'Failed to purchase credits')
    }

    return result.data as unknown as PurchaseTopOffCreditsResult
  } catch (error) {
    console.error('Error purchasing top-off credits:', error)
    throw error
  }
}

/**
 * Hook to purchase top-off credits
 * @returns Mutation object with purchase function
 */
export const usePurchaseTopOffCredits = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: purchaseTopOffCredits,
    onSuccess: data => {
      console.log('Top-off credits purchased successfully:', data)
      // If you have any credit-related queries, invalidate them here
      queryClient.invalidateQueries({ queryKey: ['user-credits'] })
    },
    onError: error => {
      console.error('Failed to purchase top-off credits:', error)
    },
  })
}
